import React, {useRef, useEffect,useState} from 'react';
import {FaSearch} from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../../context';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import "./SearchForm.css";

const SearchForm = () => {
  const {searchterm,setSearchTerm, setResultTitle} = useGlobalContext();
  const {setSearchCriteria,searchCriteria} = useGlobalContext();
  // const searchText = useRef('');
  const {searchText, setSearchText}= useGlobalContext();
  
  const {searchTextShow, setSearchTextShow}= useGlobalContext();
  //temptext
  const [tempText, setTempText] = useState('');

  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const username = localStorage.getItem('username');
    setIsLoggedIn(!!username); // Check if username exists in localStorage
  }, []);

  // useEffect(() => searchText.current.focus(), []);
  const handleSubmit = (e) => {
  e.preventDefault();
  let tempSearchTerm = searchText; // Use searchText directly

  if(tempSearchTerm.length > 60) {
    toast.error("الرجاء عدم إدخال أكثر من 60 حرفًا.");
    return;
  }
  //the most simplist yet genuis DDoS blocker , by stark
  if(tempSearchTerm === tempText) {
    return;
  }
  setTempText(tempSearchTerm);
  if(tempSearchTerm.length === 0) {
    setSearchTerm(tempSearchTerm);
    setSearchTextShow(tempSearchTerm)
    setSearchCriteria(prev => ({
      ...prev,
      location: "main",
      type: "book",
      allFilter:"category",
      isSearching: false,
      found:false,
    }));
    
    navigate("/");
  } else {

    setSearchCriteria(prev => ({
      ...prev,
      category:undefined,
      location: "main",
      allFilter:prev.allFilter === "category" ?"book":!prev.found ?"book":prev.allFilter,
      type: prev.type==="category" ?"book":!prev.found ?"book":prev.type,
      isSearching: true,
      found:false,
    }));
    setSearchTerm(tempSearchTerm);
    setSearchTextShow(tempSearchTerm)
    navigate("/");
  }
};

  

  return (
    <div className='search-form'    style={{width: "100%"}}    >
          <ToastContainer position="top-center" autoClose={5000} />
      <div className='container'>
        <div className='search-form-content'>
          <form className='search-form' onSubmit={handleSubmit} style={{    width: "100%"}}>
            <div className='search-form-elem flex flex-sb bg-white'>
            <input
                type="text"
                className='form-control'
                style={{ width: "100%" }}
                placeholder='بحث'
                value={searchText}
                onChange={(e) =>{setSearchText(e.target.value);}}
               
                maxLength={60}
                aria-label="Search"
              />
              <button type = "submit" className='flex flex-c' onClick={handleSubmit}>
                <FaSearch className='text-purple' size = {32} />
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default SearchForm